import { ComponentType, RefObject } from 'react';
import {
  Control,
  Controller,
  ControllerRenderProps,
  FieldPath,
  FieldValues,
} from 'react-hook-form';

type WithControlProps<TFieldValues extends FieldValues> = {
  control: Control<any>;
  name: FieldPath<TFieldValues>;
  ref?: RefObject<HTMLElement>;
};

export type WithControlRenderProps = ControllerRenderProps;

export const withControl = <TFieldValues extends FieldValues, U>(
  Component: ComponentType<U>,
) => {
  const ControlledComponent = ({
    control,
    name,
    ref,
    ...props
  }: WithControlProps<TFieldValues> &
    Omit<U, keyof WithControlRenderProps>) => (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <Component {...(props as U)} {...field} ref={ref} />
      )}
    />
  );

  return ControlledComponent;
};

export default withControl;
